export default __webpack_public_path__ + "static/media/solana-horizontal.c9ca9382.svg";